/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Microsoft_Tenant_InvalidInputs */



/**
* | output |
* | --- |
* | "Enter the tenant ID in the format 00000000-0000-0000-0000-000000000000." |
*
* @param {Microsoft_Tenant_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const microsoft_tenant_invalid = /** @type {((inputs?: Microsoft_Tenant_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Microsoft_Tenant_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie die Mandanten-ID im Format 00000000-0000-0000-0000-000000000000 ein.")
	return /** @type {LocalizedString} */ ("Enter the tenant ID in the format 00000000-0000-0000-0000-000000000000.")
});